import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { ReconciliationState } from '../../../../store/models/reconciliationModel';
import {Col, DatePicker, Input, Row, Select} from 'antd';
import { fetchInPatientInsurerList } from '../../../../store/actions/lookUpAction';
import ApplicationDetail from '../../../../shared/services/applicationDetail.service';
import { reArrangeOptions } from '../../../crm/inPatient/service/crmUtils';
import '../../../../index.less';
import { getReconciliationData, setIsTableLoading, setReconciliationCenterFilter, setReconciliationInsurerFilter,
  setReconciliationSearchFilter, setReconciliationStartIndex, setReconciliationTpaFilter, setReconciliationUtrDateFilter,
  setReconciliationViewIdFilter, setReconciliationdodFilter, updateReconciliationColumnFilters } from '../../../../store/actions/reconciliationAction';
import moment from 'moment';
import { dateDisabledAfterToday } from '../../../abdmHIU/abdmUtils';
import { Payer } from '../../../../shared/models/payer.model';
import { RECONCILIATION_VIEW_OPTIONS } from '../../../../shared/constants/reconciliationConstants';
import { SearchOutlined } from '@ant-design/icons';
import { isEmpty } from 'lodash';

const Filters = (): ReactElement => {
  const dispatch = useDispatch();
  useEffect((): void => {
    if (!isEmpty(configuredPayers)) { // to prevent apicall when there are no payers enabled
    dispatch(fetchInPatientInsurerList());
    }
  }, []);

  const configuredPayers = useSelector((state: RootState): Payer[] => state.payerList.allPayers);
  const InsurersList = (configuredPayers.filter((i: any): any => i.isInsurer)).map((j: any): any => {
    return {'key': j.name, 'value': j.name}; }) || [];
  const allTpa = (configuredPayers.filter((i: any): any => !i.isInsurer));
  const tpaList = allTpa.map((item: any): any => {
    return {'key': item.name, 'value': item.name}; }) || [];
  const {lastStatusUpdated, viewId} = useSelector((state: RootState): ReconciliationState => state.reconciliation || []);
  const groupProviders = ApplicationDetail.instance.getGroupProviders();
  const formattedProviderList = reArrangeOptions(groupProviders, 'providerId', 'providerName');
  const { utrNumber, sortingKey, statusFilters, startIndex, range}
  = useSelector((state: RootState): ReconciliationState => state.reconciliation || []);
  const [insurer, setInsurer] = useState();
  const [tpa, setTpa] = useState<{key: undefined, value: undefined}>({key: undefined, value: undefined});
  const [center, setCenter] = useState();
  const [dod, setDod] = useState<any>(null);
  const [utrDate, setUtrDate] = useState<any>(null);
  const [searchKey, setSearchKey] = useState();
  const [FormattedLastStatusUpdatedDate, setFormattedLastStatusUpdatedDate] = useState('');
  const [view, setView] = useState<{key: number, value: string}>({key: 1, value: 'Settled Claims'});
  const onFilter = (inputValue: string, option: any): boolean => {
    return option.value.toUpperCase().includes(inputValue.toUpperCase());
  };

  const { RangePicker } = DatePicker;
  const appDetail = ApplicationDetail.instance;
  const resetFilters = (): any => {
    setIsTableLoading(true);
    setInsurer(undefined);
    setTpa({key: undefined, value: undefined});
    setCenter(undefined);
    setUtrDate(null);
    setDod(null);
    setSearchKey(undefined);
    dispatch(updateReconciliationColumnFilters([]));
    const payload = {
      providerId: appDetail.getProviderId(),
      insurerName: undefined,
      tpaId: undefined,
      centerID: undefined,
      utrDate: null,
      dod: null,
      utrNumber,
      viewId: 1,
      searchKey: undefined,
      filters: [],
      statusFilters,
      sortingKey,
      startIndex,
      range,
    };
    dispatch(getReconciliationData(payload));
    // confirm();
  };

  const searchData = (e: any): any => {
    const keyword = e.target.value;
    setSearchKey(keyword);
  };

  useEffect((): any => {
    dispatch(setReconciliationInsurerFilter(insurer));
    dispatch(setReconciliationStartIndex(1));
  }, [insurer]);

  useEffect((): any => {
    dispatch(setReconciliationTpaFilter(tpa.key));
    dispatch(setReconciliationStartIndex(1));
  }, [tpa]);

  useEffect((): any => {
    dispatch(setReconciliationCenterFilter(center));
    dispatch(setReconciliationStartIndex(1));
  }, [center]);

  useEffect((): any => {
    dispatch(setReconciliationUtrDateFilter(utrDate));
    dispatch(setReconciliationStartIndex(1));
  }, [utrDate]);

  useEffect((): any => {
    dispatch(setReconciliationdodFilter(dod));
    dispatch(setReconciliationStartIndex(1));
  }, [dod]);

  useEffect((): any => {
    dispatch(setReconciliationSearchFilter(searchKey));
    dispatch(setReconciliationStartIndex(1));
  }, [searchKey]);

  useEffect((): any => {
    setFormattedLastStatusUpdatedDate(lastStatusUpdated ? moment(lastStatusUpdated).format('L') + ' '
    + moment(lastStatusUpdated).format('LTS') : '');
  }, [lastStatusUpdated]);

  useEffect((): any => {
    dispatch(setReconciliationViewIdFilter(view.key));
    dispatch(setReconciliationStartIndex(1));
  }, [view.key]);

  const setInputTpa = (option: any): any => {
    const selectedTPA = allTpa.find((item: any): any => {
      if (item.name === option.value) {
        return {key: item.id, value: item.name};
      }});
    setTpa(selectedTPA ? {key: selectedTPA.id, value: selectedTPA.name} as any : {key: undefined, value: undefined});
  };

  return (
    <div className="p-sm filters">
      { viewId !== 3 &&
        <Row className="flex flex-elememt flex-row" justify="space-between" align="middle" wrap={true}>
          <Col className="flex-element flex-row w-100 p-sm items-center" xs={24} sm={12} md={12} lg={6}>
            <div className="flex-element items-center w-auto mr-5 bold">
              Insurer:
            </div>
            <Select
              className="w-100 scrollable-select mouse-pointer filter-bg text-wrap"
              placeholder="All"
              optionLabelProp="label"
              filterOption={onFilter}
              allowClear={true}
              value={insurer}
              onClear={(): any => setInsurer(undefined)}
              onSelect={(index: any, option: any): any => setInsurer(option?.value)}
              options={InsurersList}
            />
          </Col>
          <Col className="flex-element w-100 flex-row p-sm items-center" xs={24} sm={12} md={12} lg={6}>
            <div className="flex-element items-center w-auto mr-5 bold">
              TPA:
            </div>
            <Select
              className="w-100 scrollable-select mouse-pointer text-wrap"
              placeholder="All"
              optionLabelProp="label"
              filterOption={onFilter}
              allowClear={true}
              value={tpa?.value}
              onClear={(): any =>  setTpa({key: undefined, value: undefined})}
              onSelect={(index: any, option: any): any => { setInputTpa(option); }}
              options={tpaList}
            />
          </Col>
          <Col className="flex-element flex-row w-100 p-sm items-center justify-between" xs={24} sm={12} md={12} lg={6}>
            <div className="flex-element items-center w-90 mr-5 bold">
              Date of Discharge:
            </div>
            <RangePicker
              allowClear={true}
              className="w-70 text-wrap"
              disabledDate={dateDisabledAfterToday}
              value={dod ? dod : null}
              onChange={(e: any): any => {
                setDod(e ? e : null);
                }}/>
          </Col>
          <Col className="flex-element flex-col item-center justify-center" xs={24} sm={12} md={12} lg={6}>
            <div className="flex-element p-sm reconciliation-status bold item-center">
              Last Status Updated: {FormattedLastStatusUpdatedDate}
            </div>
          </Col>
        </Row>
      }
      <Row className="flex flex-row flex-element" justify="space-between" align="middle" wrap={true}>
        { viewId !== 3 ?
        <>
          <Col className="flex-element flex-row w-100 p-sm items-center justify-between" xs={24} sm={12} md={12} lg={6}>
            <div className="flex-element items-center w-25 mr-5 bold">
              UTR Date:
            </div>
            <RangePicker
              allowClear={true}
              className="w-75 text-wrap"
              disabledDate={dateDisabledAfterToday}
              value={utrDate ? utrDate : null}
              onChange={(e: any): any => {
                  setUtrDate(e ? e : null);
              }}/>
          </Col>
          <Col className="flex-element w-100 flex-row p-sm items-center" xs={24} sm={12} md={12} lg={6}>
            <div className="flex-element items-center w-auto mr-5 bold">
              Center:
            </div>
            <Select
              className="w-100 scrollable-select mouse-pointer text-wrap"
              placeholder={groupProviders?.length === 0 ? '' : 'All'}
              optionLabelProp="label"
              filterOption={onFilter}
              allowClear={true}
              value={center}
              onClear={(): any => setCenter(undefined)}
              onSelect={(index: any, option: any): any => setCenter(option.value)}
              options={formattedProviderList}
              disabled={groupProviders?.length === 0}
            />
            </Col>
            <Col className="flex-element flex-row w-100 p-sm items-center justify-between" xs={24} sm={12} md={12} lg={6}>
              <Input
                onChange={searchData}
                value={searchKey}
                className="w-100 text-wrap"
                placeholder="Search UTR/Claim No"
                suffix={<SearchOutlined />}
              />
              {/* <Search
                placeholder="Search UTR/Claim No"
                className="w-100 text-wrap"
                value={searchKey}
                onSearch={(e: any): any => setSearchKey(e)}
              /> */}
            </Col>
        </> :
        <Col className="flex-element w-100 flex-row p-sm items-center" xs={24} sm={12} md={12} lg={6}/>
        }
        <Col className="flex-element flex-row w-100 p-sm items-center justify-between" xs={24} sm={12} md={12} lg={6}>
            <div className="flex-element flex-row w-100 p-sm items-center justify-center">
              <div className="flex-element items-center w-10 mr-5 bold">
                View:
              </div>
              <Select
                optionLabelProp="value"
                value={view.value}
                onSelect={(index: any, option: any): any => setView(option)}
                className="w-90 mouse-pointer text-wrap"
                options={RECONCILIATION_VIEW_OPTIONS}
              />
            </div>
            <div onClick={resetFilters} className="mouse-pointer text-primary f_b bold w-100">
              Reset Filters
            </div>
        </Col>
      </Row>
    </div>
  );
};

export default Filters;
